import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { Observable } from 'rxjs/Observable';
import { constant } from '../app.constants';
import { ParentService } from '../pages/A2-utils/ParentClass/ParentService';
import { map } from 'rxjs/operators';
import { ITypeLicense as ITypeLicenseResponse } from 'app/core/interfaces/qualification.interface';

export interface ITypeLicense {
  typelicenseid?: number,
  description: string,
  isactive: boolean,
  documentextract: boolean,
  categorytypelicenseid: number,
  categorytypelicense: any;
  modifiedon: any;
  addedon: any;
}

export interface ITypeLicenseProvider {
  ProviderId: number,
  TypeLicenseIds: any[]
}

export interface IProviderLicense {
  providerid: number;
  TypeLicenseProviderId: number;
  expiration: string;
  imagebase64: any;
  MimeType: string;
  effectivedate: string;
}

@Injectable()
export class LicensesService  extends ParentService{

  constructor(private _http: Http, private toastrAlertHelper: ToastrAlertHelper) {
    super();
  }

  getCategoryTypeLicense() {
    const url = constant.URL_CATEGORY_TYPE_LICENSE;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  postTypeLicense(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_TYPE_LICENSE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw( this.toastrAlertHelper.error(error.json().message)));
  }

  putTypeLicense(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_TYPE_LICENSE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw( this.toastrAlertHelper.error(error.json().message)));
  }

  getTypeLicenseList(show: boolean) {
    const url = constant.URL_TYPE_LICENSE + '/List/' + show;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  getTypeLicenseProvider(ProviderId: number) {
    const url = constant.URL_TYPE_LICENSE_PROVIDER + '/List/' + ProviderId;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  postTypeLicenseProvider(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_TYPE_LICENSE_PROVIDER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw( this.toastrAlertHelper.error(error.json().message)));
  }

  getProviderLicense(ProviderId: number) {
    const url = constant.URL_PROVIDER_LICENSE + '/List/' + ProviderId;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  getTypeLicenseProviderId(ProviderId: number) {
    const url = constant.URL_TYPE_LICENSE_PROVIDER + '/Provider/' + ProviderId;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  getTypeLicenseVehicleProviderId(ProviderId: number) {
    const url = constant.URL_TYPE_LICENSE_PROVIDER + '/Vehicle/' + ProviderId;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  getTypeLicenseDriverProviderId(ProviderId: number) {
    const url = constant.URL_TYPE_LICENSE_PROVIDER + '/Driver/' + ProviderId;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  postProviderLicense(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_PROVIDER_LICENSE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw( this.toastrAlertHelper.error(error.json().message)));
  }

  getProviderLicenseValid(ProviderId: number) {
    const url = constant.URL_PROVIDER_LICENSE + '/Valid/' + ProviderId;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  getProviderLicenseStatus() {
    const url = constant.URL_PROPIVER_LICENSE_STATUS;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  putProviderLicense(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_PROVIDER_LICENSE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw( this.toastrAlertHelper.error(error.json().message)));
  }

  getHistoryLicenses(id:any) {
    let url = `${constant.URL_TYPE_LICENSE}/${id}/History`;
    return this._http.get(url, this.getHeader()).map(res => res.json())
  }

  getDriverTypeLicenses(): Observable<ITypeLicenseResponse[]> {
    const url = `${constant.URL_TYPE_LICENSE}/DriverTypeLicenses`;
    return this._http.get(url, this.getHeader())
      .map((response: Response) => response.json() as ITypeLicenseResponse[])
      .catch((error) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/licenses.service.ts